import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline, GlobalStyles } from '@mui/material';

declare module '@mui/material/styles' {
  interface Palette {
    blue?: {
      light: string;
      main: string;
      medium: string;
      dark: string;
      lightTransparent: string;
    };
  }
  interface PaletteOptions {
    blue?: {
      light: string;
      main: string;
      medium: string;
      dark: string;
      lightTransparent: string;
    };
  }
}

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      light: '#80ade6',
      main: '#2c76d5',
      dark: '#1d5195',
    },
    secondary: {
      main: '#5c6bc0',
    },
    blue: {
      light: '#80ade6',
      main: '#2c76d5',
      medium: 'rgb(128,173,230)',
      dark: '#1d5195',
      lightTransparent: '#80ade62b',
    },
    grey: {
      300: '#e0e0e0',
      400: '#bdbdbd',
    },
  },
  typography: {
    fontFamily: 'var(--tms-sans)',
    h1: {
      fontFamily: 'Lobster, cursive',
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          minHeight: 40,
          borderRadius: 10,
          paddingInline: 16,
          fontWeight: 600,
          lineHeight: 1.25,
          textTransform: 'none',
        },
        sizeSmall: {
          minHeight: 32,
          paddingInline: 12,
        },
        sizeLarge: {
          minHeight: 48,
          paddingInline: 24,
        },
        outlined: {
          borderWidth: 1,
          '&:hover': {
            borderWidth: 1,
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          color: '#3b3b3b',
          fontFamily: 'var(--tms-sans)',
          backgroundColor: '#1a1a2e',
          background:
            'linear-gradient(0deg, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.35)), linear-gradient(135deg, #1d5195 0%, #2c76d5 40%, #1a1a2e 100%)',
          backgroundAttachment: 'fixed',
          margin: 0,
        },
      },
    },
  },
});

export const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <GlobalStyles
      styles={{
        html: { height: 'auto !important', overflow: 'visible !important' },
        body: { height: 'auto !important', overflow: 'visible !important' },
        '#root': { minHeight: '100vh' },
      }}
    />
    {children}
  </ThemeProvider>
);
